import { ojs, app, v } from "modular-openscriptjs";
import { either, formatThousand } from "../helpers";
import Navigation from "./Navigation";
import { dom } from "../fotastart";
import { STRINGS, gc, uc, pc, NavItem } from "../declarations";

const h = app("h");
const $e = app("$e");

export default class SideNav extends Navigation {
    name = "SideNav";
    tooltips = [];

    /**
     * Parse a nav item
     * @param {NavItem} item
     */
    parseItem(item, ...args) {
        if (!item.condition()) return null;

        let collapsed = pc.sideNavCollapsed.value;

        return h.li(
            { app_hook: "app-nav", app_nav_hook: item.appHook },
            h.a(
                {
                    role: "button",
                    class: "dropdown-item d-flex align-items-center gap-3 px-2 position-relative",
                    onclick: item.onclick,
                },
                h.span({ class: "icon", style: "--fs: 1.5rem;" }, item.icon()),
                collapsed ? "" : h.span({ class: "fs-5" }, item.text),
                either(item.children.length > 0, {
                    class: "dropdown-toggle nav-link",
                    role: "button",
                    data_bs_toggle: "dropdown",
                    aria_expanded: "false",
                }),
                either(collapsed, {
                    data_bs_title: item.text,
                    data_bs_placement: "right",
                    data_bs_toggle: "tooltip",
                }),
            ),
            either(
                item.children.length > 0 && this.dropdownDir() !== "dropdown",
                { class: this.dropdownDir() },
            ),
            this.dropdown(item.children),
            ...args,
        );
    }

    render(items, collapsed, ...args) {
        return h.div(
            {
                class: `side-navbar d-grid gap-2 py-5 ${
                    collapsed.value ? "collapsed" : ""
                }`,
                style: `--scrollbar-bg: rgb(var(--bs-light-rgb));`,
                c_attr: {
                    class: `h-100 d-none d-md-block ${collapsed.value ? "col-md-1 col-lg-1" : "col-lg-3 col-md-4"}`,
                    style: "transition: width 0.3s ease;",
                    ojs_hook: "side-nav-container",
                },
            },

            h.ul(
                {
                    class: "nav flex-column gap-2",
                },
                this.renderNav(items.value),
            ),

            either(gc.auth.value, () => [
                h.hr(),

                h.div(
                    { class: "dropdown" },
                    h.a(
                        {
                            role: "button",
                            class: "d-block position-relative",
                            onclick: "route.to('/wallet')",
                        },
                        either(collapsed.value, {
                            data_bs_title:
                                "Wallet Balance " +
                                STRINGS.CAPA_SYMBOL +
                                formatThousand(uc.capa?.value?.balance ?? 0),
                            data_bs_placement: "right",
                            data_bs_toggle: "tooltip",
                        }),
                        h.div(
                            {
                                class: "d-flex align-items-center gap-3",
                            },
                            either(collapsed.value, {
                                class: "justify-content-center",
                            }),

                            h.div(
                                {
                                    class: "square-profile fw-500 text-primary",
                                },
                                h.span(
                                    { class: "icon" },
                                    h.i({ class: "bi bi-wallet fs-2" }),
                                ),
                            ),

                            collapsed.value
                                ? ""
                                : h.div(
                                      { class: "d-grid gap-1 lh-1" },
                                      v(uc.capa, (capa) => {
                                          return h.span(
                                              {
                                                  class: "fs-5",
                                              },
                                              STRINGS.CAPA_SYMBOL,
                                              formatThousand(
                                                  capa?.value?.balance ?? 0,
                                              ),
                                          );
                                      }),
                                  ),
                        ),
                    ),
                ),

                h.div(
                    { class: "dropdown" },
                    h.a(
                        {
                            class: "dropdown-item d-flex gap-2 cursor-pointer",
                            onclick: `sendEvent('${$e.user.needs.referFriend}')`,
                        },
                        either(collapsed.value, {
                            data_bs_title: "Refer a friend",
                            data_bs_placement: "right",
                            data_bs_toggle: "tooltip",
                            class: "justify-content-center",
                        }),
                        h.span(
                            { class: "icon" },
                            h.i({ class: "bi bi-share" }),
                        ),
                        collapsed.value
                            ? ""
                            : h.div(
                                  { class: "d-flex flex-column" },
                                  h.span({ class: "text" }, `Refer A Friend`),
                                  h.span(
                                      {
                                          class: "form-text text-wrap",
                                      },
                                      `Earn 50% on their first order`,
                                  ),
                              ),
                    ),
                ),

                h.div(
                    { class: "dropdown" },
                    h.a(
                        {
                            class: "dropdown-item d-flex gap-2",
                            href: "https://carata.co",
                        },
                        either(collapsed.value, {
                            data_bs_title: "About Carata",
                            data_bs_placement: "right",
                            data_bs_toggle: "tooltip",
                            class: "justify-content-center",
                        }),
                        h.span(
                            { class: "icon" },
                            h.i({ class: "bi bi-info-circle" }),
                        ),
                        collapsed.value
                            ? ""
                            : h.span({ class: "text" }, "About Carata"),
                    ),
                ),

                h.div(
                    { class: "dropdown" },
                    h.a(
                        {
                            class: "dropdown-item d-flex gap-2",
                            href: "#",
                            onclick: h.func("openCustomerSupport"),
                        },
                        either(collapsed.value, {
                            data_bs_title: "Customer Support",
                            data_bs_placement: "right",
                            data_bs_toggle: "tooltip",
                            class: "justify-content-center",
                        }),
                        h.span(
                            { class: "icon" },
                            h.i({ class: "bi bi-headset" }),
                        ),
                        collapsed.value
                            ? ""
                            : h.span({ class: "text" }, "Customer Support"),
                    ),
                ),
            ]),

            ...args,
        );
    }
}

ojs(SideNav);
